import React from 'react';
import { Box, Typography, Button, Container } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { themeColors } from '../styles/theme';

const NotFound: React.FC = () => {
  const navigate = useNavigate();

  return (
    <>
      <Helmet>
        <title>Page Not Found (404) | Suntap</title>
        <meta name="description" content="The page you're looking for doesn't exist. Return to Suntap to find the sunniest pub gardens near you." />
        <link rel="canonical" href="https://sun-tap.com/404" />
        <meta name="robots" content="noindex, nofollow" />
        <meta property="og:title" content="Page Not Found | Suntap" />
        <meta property="og:description" content="The page you're looking for doesn't exist. Return to Suntap to find sunny pub gardens." />
        <meta property="og:type" content="website" />
      </Helmet>
      <Container maxWidth="sm">
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '80vh',
            textAlign: 'center',
            p: 3,
          }}
        >
          <Typography
            variant="h1"
            sx={{
              fontSize: '8rem',
              fontWeight: 700,
              color: themeColors.orange,
              lineHeight: 1,
              mb: 2,
            }}
          >
            404
          </Typography>
          <Typography
            variant="h4"
            sx={{
              color: themeColors.darkBackground,
              mb: 3,
              fontWeight: 600,
            }}
          >
            Oops! Page Not Found
          </Typography>
          <Typography
            variant="body1"
            sx={{
              color: 'rgba(34, 34, 34, 0.7)',
              mb: 4,
              maxWidth: '400px',
            }}
          >
            The page you're looking for doesn't exist or has been moved. Let's get you back on track!
          </Typography>
          <Button
            variant="contained"
            onClick={() => navigate('/')}
            sx={{
                background: 'transparent',
                color: '#000',
                fontSize: '1.1rem',
                fontFamily: "ApfelGrotezkRegular",
                borderRadius: '48px',
                transition: 'all 0.2s ease',
                '&:hover': {
                    background: themeColors.lightYellow,
                },
                padding: '4px',
                backgroundColor: themeColors.lager,
            }}
          >
            Return Home
          </Button>
        </Box>
      </Container>
    </>
  );
};

export default NotFound; 